<template>
  <div>
    <!-- <v-container> -->
    <!-- <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'last_15_days'"
          v-model="selectedDate"
        ></date-filter>
      </div> -->
    <Typography h2 bold label="จำนวนผู้ลงทะเบียน" />
    <v-layout row wrap class="mt-2">
      <v-flex xs12 sm12 style="display: flex; justify-content: space-between; align-items: center">
        <div style="display: flex; align-items: center; width: 50%">
          <multiselect
            v-model="dealertype"
            label="label"
            :allow-empty="false"
            single-select
            :options="optionType"
            @input="getData"
          ></multiselect>

          <div class="ml-2 form-control" style="width: 55%">
            <date-picker
              range
              @input="onSearch"
              :shortcuts="shortcuts"
              :append-to-body="false"
              :clearable="false"
              :editable="false"
              input-class="dateSearch"
              name="DateSearch"
              v-model="selectedDate"
              valueType="date"
              format="DD/MM/YYYY"
              placeholder="Début - Fin"
            >
            </date-picker>
          </div>
        </div>
        <div v-if="dealertype.value == 'depausersregisterbymembertype'">
          <v-btn
            variant="outlined"
            :v-tooltip="$t('export')"
            @click="modalExport = true"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
          <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-3">
      <div v-if="loading" class="text-xs-center pt-5">
        <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="data.length">
          <div
            id="chart"
            class="flex-all-center"
            v-if="dealertype.value == 'depausersregisterbymembertype'"
          >
            <v-flex xs12 sm10 md8>
              <apexchart
                :key="piechartkey"
                type="pie"
                width="100%"
                :options="pieChartOptions"
                :series="pieSeries"
              ></apexchart>
            </v-flex>
          </div>
          <div id="chart" v-else>
            <apexchart
              :key="linechartkey"
              type="line"
              height="350"
              :options="lineChartOptions"
              :series="lineSeries"
            ></apexchart>
          </div>
          <Typography class="mt-3" h2 bold label="รายละเอียด" />
          <v-data-table
            v-bind:pagination.sync="pagination"
            :headers="headers"
            :items="data"
            class="elevation-1"
            :loading="loading"
            expand
            hide-actions
            item-key="name"
          >
            <template v-slot:items="props">
              <tr>
                <td v-if="props.item.timestamp" class="text-xs-left pa-3">
                  <!-- {{ props.item.timestamp | DateFormat('DD/MM/YYYY') }} -->
                  <Typography
                    h5
                    semiBold
                    :label="props.item.timestamp | DateFormat('DD/MM/YYYY')"
                  />
                </td>
                <td v-else class="text-xs-left pa-3">
                  <Typography
                    :color="colorLabel(props.item.membertype)"
                    h5
                    semiBold
                    :label="props.item.membertype"
                  />
                </td>
                <td
                  class="text-xs-left pa-3"
                  style="display: flex"
                  v-if="dealertype.value == 'depausersregisterbymembertype'"
                >
                  <Typography h5 semiBold :label="props.item.percent" />%
                </td>

                <td class="text-xs-left pa-3">
                  <Typography h5 semiBold :label="props.item.total" />
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <div class="text-xs-center mt-5" style="color: grey; font-size: 24px">ไม่พบข้อมูล</div>
        </div>
      </div>
    </div>
    <!-- </v-container> -->
    <v-dialog v-model="modalExport" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <div></div>

            <v-icon style="display: flex; align-items: center" @click="modalExport = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout column wrap justify-center align-center class="mb-3">
              <img
                src="/static/img/Export.png"
                alt
                class="responsive-img mb-1"
                style="height: 70px"
              />
              <Typography h2 bold label="ส่งออกข้อมูล" />
              <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
            </v-layout>
            <div class="text-xs-center">
              <div class="text-xs-center rsu">
                <v-btn
                  :loading="loading"
                  class="rsu"
                  round
                  small
                  outline
                  color="primary"
                  @click.stop="modalExport = false"
                  >ยกเลิก</v-btn
                >
                <v-btn
                  class="rsu"
                  :loading="loading"
                  round
                  small
                  depressed
                  style="color: #ffef01"
                  color="primary"
                  @click.stop="exportData"
                  >ยืนยัน</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import apexchart from 'vue-apexcharts'
import Typography from '@/components/elements/Typography.vue'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import DatePicker from 'vue2-datepicker'
import Exportxlsx from '@/components/elements/exportxlsx'

export default {
  components: {
    DateFilter,
    Multiselect,
    apexchart,
    Typography,
    DatePicker,
    Exportxlsx,
  },
  data() {
    return {
      modalExport: false,
      exData: [],
      linechartkey: 0,
      lineSeries: [
        {
          name: 'Linechart',
          data: [],
        },
      ],
      lineChartOptions: {
        colors: ['#26588B'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download:
                '<v-btn variant="outlined" icon  color="#BECCDB"  style="border-radius: 50% !important"  > <img src="/static/img/exportfilter.png"  alt  class="responsive-img"   style="height: 16px"   />  </v-btn>',
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              customIcons: [],
            },
            autoSelected: 'zoom',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: '',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'datetime',
          categories: [],
        },
      },
      piechartkey: 0,
      pieSeries: [],
      pieChartOptions: {
        chart: {
          type: 'pie',
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      dealertype: {
        label: 'จำนวนผู้ลงทะเบียน/วัน',
        value: 'depausersregisterbydate',
      },
      optionType: [
        {
          label: 'จำนวนผู้ลงทะเบียน/วัน',
          value: 'depausersregisterbydate',
        },
        {
          label: 'จำนวนผู้ลงทะเบียน/ประเภทสมาชิก',
          value: 'depausersregisterbymembertype',
        },
      ],
      loading: false,
      currentDate: new Date(),
      // selectedDate: {
      //   start: moment()
      //     .subtract(14, 'days')
      //     .format('YYYY-MM-DD 00:00'),
      //   end: moment().format('YYYY-MM-DD')
      // },
      selectedDate: [new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), new Date(new Date())],
      pagination: { rowsPerPage: 50 },
      data: [],
      total: 0,
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    shortcuts() {
      const currentDate = new Date()
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
      const fortyEightHoursAgo = new Date(Date.now() - 48 * 60 * 60 * 1000)
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
      return [
        {
          text: '24 ชั่วโมงที่แล้ว',
          onClick() {
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            const start = new Date(
              twentyFourHoursAgo.getFullYear(),
              twentyFourHoursAgo.getMonth(),
              twentyFourHoursAgo.getDate(),
              twentyFourHoursAgo.getHours(),
              twentyFourHoursAgo.getMinutes(),
              twentyFourHoursAgo.getSeconds()
            )

            const date = [start, end]
            return date
          },
        },
        {
          text: '48 ชั่วโมงที่แล้ว',
          onClick() {
            const start = new Date(
              fortyEightHoursAgo.getFullYear(),
              fortyEightHoursAgo.getMonth(),
              fortyEightHoursAgo.getDate(),
              fortyEightHoursAgo.getHours(),
              fortyEightHoursAgo.getMinutes(),
              fortyEightHoursAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )

            const date = [start, end]
            return date
          },
        },
        {
          text: 'อาทิตย์ที่แล้ว',
          onClick() {
            const start = new Date(
              oneWeekAgo.getFullYear(),
              oneWeekAgo.getMonth(),
              oneWeekAgo.getDate(),
              oneWeekAgo.getHours(),
              oneWeekAgo.getMinutes(),
              oneWeekAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: '15 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
            const end = new Date(currentDate)
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: 'เดือนที่แล้ว',
          onClick() {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
            const end = new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate()
            )
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: '365 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
            const end = new Date()
            // return a Date
            const date = [start, end]
            return date
          },
        },
      ]
    },
    headers() {
      if (this.dealertype.value == 'depausersregisterbydate') {
        return [
          { text: 'วันที่', value: 'timestamp', align: 'left', width: '80%', sortable: false },
          { text: 'จำนวน', value: 'total', align: 'left', width: '20%', sortable: false },
        ]
      } else {
        return [
          {
            text: 'ประเภทสมาชิก',
            value: 'membertype',
            align: 'left',
            width: '60%',
            sortable: false,
          },
          {
            text: 'เปอร์เซ็นต์',
            value: 'applicantstatus',
            align: 'left',
            width: '20%',
            sortable: false,
          },
          { text: 'จำนวน', value: 'total', align: 'left', width: '20%', sortable: false },
        ]
      }
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async exportData() {
      this.loading = true
      await this.getData('export')
      this.loading = false
      this.$refs.exbtn.exportxlsx()
      this.modalExport = false
    },
    onSearch() {
      this.getData()
    },
    colorLabel(name) {
      if (name === 'บริษัทจำกัด/บมจ') {
        return 'color-darkBlue2'
      } else if (name === 'บุคคลธรรมดา') {
        return 'color-lightPurple'
      } else if (name === 'ทะเบียนพาณิชย์') {
        return 'color-lightYellow2'
      } else if (name === 'วิสาหกิจชุมชน และวิสาหกิจขนาดกลางและขนาดย่อม') {
        return 'color-lightBlue'
      } else if (name === 'ห้างหุ้นส่วนจำกัด') {
        return 'color-lightOrange'
      } else if (name === 'สถาบันการศึกษา') {
        return 'color-lightRed'
      } else if (name === 'องค์การเอกชน (สมาคม/สภาอุตสาหกรรม/สภาหอการค้า เป็นต้น)') {
        return 'color-complete'
      } else if (name === 'วิสาหกิจเริ่มต้น (Digital Startup)') {
        return 'color-lightSugar'
      } else if (name === 'หน่วยงานภาครัฐ') {
        return 'color-lightGreen'
      } else if (name === 'มหาวิทยาลัย') {
        return 'color-lightPink'
      } else if (name === 'เกษตรกรที่มีการขึ้นทะเบียนกับหน่วยงานภาครัฐ') {
        return 'color-lightGreen2'
      } else if (name === 'สหกรณ์') {
        return 'color-darkBlue3'
      } else if (name === 'หนังสือรับรองทางการค้าหรือบริการ') {
        return 'color-lightPink2'
      } else if (name === 'มูลนิธิ') {
        return 'color-lightYellow3'
      } else if (name === 'วิสาหกิจขนาดกลางและขนาดย่อม') {
        return 'color-lightGreen3'
      } else {
        return 'color-mediumGrey'
      }
    },
    colorLabelGraph(name) {
      if (name === 'บริษัทจำกัด/บมจ') {
        return '#1C64AF'
      } else if (name === 'บุคคลธรรมดา') {
        return '#B656C6'
      } else if (name === 'ทะเบียนพาณิชย์') {
        return '#FFCD00'
      } else if (name === 'วิสาหกิจชุมชน และวิสาหกิจขนาดกลางและขนาดย่อม') {
        return '#7DBDFF'
      } else if (name === 'ห้างหุ้นส่วนจำกัด') {
        return '#FF9533'
      } else if (name === 'สถาบันการศึกษา') {
        return '#ED5252'
      } else if (name === 'องค์การเอกชน (สมาคม/สภาอุตสาหกรรม/สภาหอการค้า เป็นต้น)') {
        return '#52c41a'
      } else if (name === 'วิสาหกิจเริ่มต้น (Digital Startup)') {
        return '#935F5F'
      } else if (name === 'หน่วยงานภาครัฐ') {
        return '#73DCC3'
      } else if (name === 'มหาวิทยาลัย') {
        return '#E786F6'
      } else if (name === 'เกษตรกรที่มีการขึ้นทะเบียนกับหน่วยงานภาครัฐ') {
        return '#0FA3B1'
      } else if (name === 'สหกรณ์') {
        return '#1D699D'
      } else if (name === 'หนังสือรับรองทางการค้าหรือบริการ') {
        return '#FF7592'
      } else if (name === 'มูลนิธิ') {
        return '#FECB95'
      } else if (name === 'วิสาหกิจขนาดกลางและขนาดย่อม') {
        return '#307825'
      } else {
        return '#818181'
      }
    },
    getData(type) {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate[0]).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate[1]).format('YYYY-MM-DD'), // YYYY-MM-DD
        }
        this.loading = true
        api[this.dealertype.value](data, async (err, response) => {
          this.loading = false
          // this.data = response.data
          this.setupPieChart(response.data)
          this.setupLineChart(response.data)
          const total = this.pieSeries.reduce((a, b) => a + b, 0)
          const percent = this.pieSeries.map((value) => (value / total) * 100)

          this.data = response.data.map((item, index) => {
            return {
              timestamp: item.timestamp,
              applicantstatus: item.applicantstatus,
              total: item.total,
              membertype: item.membertype,
              percent: percent[index].toFixed(1),
            }
          })
          if(type === 'export'){
            await this.setEx(this.data) 
          }

          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    },
    setEx(data) {
      if (data) {
        let ex = []
        data.forEach((ele) => {
          let obj = {
            ประเภทสมาชิก: ele.membertype,
            เปอร์เซ็นต์: ele.percent,
            จำนวน: ele.total,
          }
          ex.push(obj)
        })
        this.exData = ex
      }
    },
    setupLineChart(data) {
      if (data.length) {
        var cat = data.map((el) => (el.timestamp ? el.timestamp : 'ไม่ระบุ'))
        var series = data.map((el) => parseInt(el.total))
        this.lineSeries[0].data = series
        this.lineChartOptions.xaxis.categories = cat
      } else {
        this.lineSeries[0].data = []
        this.lineChartOptions.xaxis.categories = []
      }
      this.linechartkey++
    },
    setupPieChart(data) {
      this.pieSeries = data.map((el) => parseInt(el.total))
      this.pieChartOptions.labels = data.map((el) => (el.membertype ? el.membertype : 'ไม่ระบุ'))
      this.pieChartOptions.colors = data.map((el) =>
        el.membertype ? this.colorLabelGraph(el.membertype) : 'ไม่ระบุ'
      )
      this.piechartkey++
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Depausersregister.vue